import { createTheme } from '@mui/material';
// KEEP THIS CONSIST WITH src/index.css

export default createTheme({
  palette: {
    mode: 'dark',
    background: { default: '#070707', paper: '#070707' },
    text: {
      primary: '#FFFFFF'
    },
    primary: {
      light: '#E3FF57',
      main: '#D0F223',
      dark: '#C5E911'
    },
    secondary: {
      light: '#C4C4C4',
      main: '#747474',
      dark: '#454545'
      // dark: '#2E2E2E'
    },
    info: {
      light: '#976FC4',
      main: '#9747FF',
      dark: '#603491'
    },
    success: {
      light: '#6EC1FF',
      main: '#3BA1FF',
      dark: '#2E80CC'
    },
    warning: {
      light: '#FFBB33',
      main: '#FFAA00',
      dark: '#FF9500'
    },
    error: {
      light: '#FF3333',
      main: '#FF0000',
      dark: '#D13939'
    },
    grey: {
      100: '#f8f9fa',
      200: '#f0f2f5',
      300: '#dee2e6',
      400: '#ced4da',
      500: '#adb5bd',
      600: '#6c757d',
      700: '#495057',
      800: '#343a40',
      900: '#212529'
    }
  },
  typography: {
    fontFamily: [
      'Roboto',
      'sans-serif',
      '"Helvetica Neue"',
      '-apple-system',
      'Arial',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(','),
    body1: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px'
    },
    h1: {
      fontSize: '36px',
      fontWeight: 400,
      lineHeight: '42px'
    },
    h2: {
      fontSize: '32px',
      fontWeight: 400,
      lineHeight: '38px'
    },
    h3: {
      fontSize: '26px',
      fontWeight: 400,
      lineHeight: '30px'
    },
    h4: {
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '28px'
    },
    h5: {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '24px'
    },
    h6: {
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '22px'
    }
  }
})
